import React from 'react'

import { Badge, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import isSafeUrl from 'Utils/isSafeUrl'

import { formatMoneyValue, renderDate as formatDateValue } from '../../../formatter'
import RefundedTag from '../../RefundedTag'

const AWAITING_PAYMENT = 'Awaiting payment from buyer'
const AWAITING_PAYMENT_TOOLTIP =
  'This is an enterprise transaction. Please allow 30-60 days for the payment to be processed.'

export const paymentProcessingFeeTooltip = (
  <>
    Transaction fees are applied for every purchase. You can find more about
    transaction fees by{' '}
    <a
      href="https://help.cgtrader.com/hc/en-us/articles/33947843875345-Payment-processing-fees"
      target="_blank"
      rel="noopener noreferrer"
    >
      clicking here
    </a>
    .
  </>
)

export const renderLinkCell = ({ value }) => {
  if (!value) return null
  const { url, text } = value
  if (!isSafeUrl(url)) return <span>{text}</span>
  return <a href={url}>{text}</a>
}

export const renderMoneyCell = ({ value }) => {
  const formatted = formatMoneyValue(value)
  if (Number.isNaN(Number(formatted))) {
    return <span>{value}</span>
  }
  return <span>{`$${formatted}`}</span>
}

export function makeFinalPayoutCell(onOpenRefund, translate) {
  return function renderFinalPayoutCell({ value, row }) {
    const refundId = row && row.refundId
    if (refundId) {
      return (
        <RefundedTag
          refundId={refundId}
          onOpenRefund={onOpenRefund}
          label={translate('profile.my_sales.refunded_badge')}
        />
      )
    }
    return renderMoneyCell({ value })
  }
}

export const renderPercentageCell = ({ value }) => <span>{`${value ?? 0}%`}</span>

export const renderDateCell = ({ value }) => <span>{formatDateValue(value)}</span>

export const renderTransactionIdCell = ({ value }) => {
  if (value === AWAITING_PAYMENT) {
    return (
      <Tooltip
        content={AWAITING_PAYMENT_TOOLTIP}
        tooltipClassName="transaction-id-tooltip"
        place="top"
      >
        <div className="transaction-id-tooltip-wrapper">
          <span className="transaction-id-tooltip-text">{value}</span>
        </div>
      </Tooltip>
    )
  }
  return <span>{value}</span>
}

export const renderPriceCell = ({ value }) => {
  const numericValue = Number(value)
  if (Number.isNaN(numericValue)) return <span>{value}</span>
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(numericValue)
  return <span>{formatted}</span>
}

const UNPAID_STATUSES = new Set(['To be paid', 'Awaiting payment from buyer', ''])

export const renderStatusCell = ({ value }) => {
  const isPaid = !UNPAID_STATUSES.has(value)
  return (
    <Badge type={isPaid ? 'light-green' : 'light'}>
      {isPaid ? 'Paid' : 'To be paid'}
    </Badge>
  )
}
